module.exports = __webpack_public_path__ + "img/mask-home-banner-zh_HK.df36ebe2.png";